import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {ShareddataService} from '../../shared/services/shareddata.service';
import {GlobalsService} from '../../shared/services/globals.service';
import {AbstractBffApi} from '../../models/sharedinterface';

@Component({
  selector: 'app-toolview',
  templateUrl: './toolview.component.html',
  styleUrls: ['./toolview.component.scss']
})
export class ToolviewComponent implements OnInit {

  iframesource: any;
  iframeHeight: number;
  languagekey: string;
  ispreloading: boolean;

  bffapi: AbstractBffApi;

  @ViewChild('myframe') myframe: ElementRef;

  private buildEntrypointIframeUri(origin: string, iFrameUrl: string, token: string): string {

    // ows case (dev-prod) iFrameUrl
    // https://dev-ows.media4.ch/display?t=eyJ0eXA
    // https://ows.media4.ch/display?t=eyJ0eXA
    // if (iFrameUrl === "https://ows.media4.ch/display"
    //   || iFrameUrl === "https://dev-ows.media4.ch/display") {
    //   return iFrameUrl + "?t=" + token;
    // } // if
    if (this.globalsservice.getOwsEntryPoints().hasOwnProperty(iFrameUrl)) {
      return iFrameUrl + '?t=' + token;
    } // if

    // campaign viewer case (dev-prod)
    // https://tools.media4.ch/cv_dev/longines/eyJ0eXA
    // https://tools.media4.ch/cv/longines/eyJ0eXA
    // if (iFrameUrl === "https://tools.media4.ch/cv/longines"
    //   || iFrameUrl === "https://tools.media4.ch/cv_dev/longines") {
    //   return iFrameUrl + "/" + token;
    // } // if
    if (this.globalsservice.getCampaignviewerEntryPoints().hasOwnProperty(iFrameUrl)) {
      return iFrameUrl + '/' + token;
    } // if


    // instore case (dev-prod)
    // https://dev-is.media4.ch/market/eyJ
    // https://is.media4.ch/market/eyJ
    // if (iFrameUrl === "https://is.media4.ch/market"
    //   || iFrameUrl === "https://dev-is.media4.ch/market") {
    //   return iFrameUrl + "/" + token;
    // } // if
    if (this.globalsservice.getInstoreEntryPoints().hasOwnProperty(iFrameUrl)) {
      return iFrameUrl + '/' + token;
    } // if

    // By default, use this scheme
    return iFrameUrl + '/' + token;
  } // buildIframeUri

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    // console.log('received message from child');
    // console.log(event);

    switch (event.origin) {

      // For aos dev-prod and ows,
      case this.globalsservice.getAosHost(): // https://aos2.media4.ch

        if (event.data.instruction === 'updateIFrame') {
          const url = this.buildEntrypointIframeUri(event.origin, event.data.iFrameUrl, event.data.t);


          console.log("change iframe url from toolview");
          this.shareddata.changeiframeURL(url);

          // this.iframesource = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } // if

        if (event.data.instruction === 'sessionPosted') {
          const query = this.bffapi.setAOSSid(event.data.sid, event.data.source).subscribe(() => {
          });
        } // if
        break;
      default:
      // Nothing for default
    } // switch
  } // onMessage

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.iframeHeight = this.getIFrameHeight();
  }

  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private apifactory: ApiFactoryService,
    private element: ElementRef<HTMLElement>,
    private shareddata: ShareddataService,
    private globalsservice: GlobalsService,
  ) {

    this.bffapi = this.apifactory.createBffApi();

    this.shareddata.currentiframeURL.subscribe((url) => {
      // console.log('update iframe source to url: ' + url);
      this.iframesource = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    });
    this.shareddata.ispreloading$.subscribe((data) => {
      this.ispreloading = data;
    });
  }

  ngOnInit(): void {
    // Mainly the tool is loaded at route guard
    // Main reason: the url changes according to the route
  }

  // // Return /ext/<toolid>/<toolkeyword> style path
  // getPortalToolUrl(languagekey: string, toolid: number, toolkeyword: string) {
  //   return '/' + languagekey + '/ext/' + toolid + '/' + toolkeyword;
  // } // getPortalToolPath

  getIFrameHeight(): number {
    const headerHeight = this.element.nativeElement.getBoundingClientRect().top;
    const height = window.innerHeight - headerHeight;
    return height ? height : 0;
  }

  onIFrameLoaded() {
    this.shareddata.setIspreloading(false);
    this.iframeHeight = this.getIFrameHeight();
  }

}
